window.addEventListener('load', function() {

    const passwordForm = document.querySelector('#passwordForm');
    const collectionUrl = document.querySelector('#collectionUrl');
    const collectionPassword = document.querySelector('#collectionPassword');
    const passwordInput = document.querySelector('#passwordInput');

    if(passwordForm) passwordForm.addEventListener('submit', function(e) {
        e.preventDefault();
        if(collectionPassword.value === passwordInput.value) {
            setCookie('hasPassword', 'true', 30);
            document.location.href = collectionUrl.value;
        }
    });

});